declare type Key = string | number

export interface EnumItem {
  id: number;
  mark: string;

  [key: Key]: any;
}

const paymentStatusOptions: EnumItem[] = [
  {
    id: 1,
    mark: '待付款'
  },
  {
    id: 2,
    mark: '部分付款'
  },
  {
    id: 3,
    mark: '已付款'
  },
  {
    id: 4,
    mark: '无需付款'
  }
]

const invoiceStatusOptions: EnumItem[] = [
  {
    id: 1,
    mark: '待开票'
  },
  {
    id: 2,
    mark: '部分开票'
  },
  {
    id: 3,
    mark: '已开票'
  },
  {
    id: 4,
    mark: '无需开票'
  }
]

const storageStatusOptions: EnumItem[] = [
  {
    id: 0,
    mark: '待入库'
  },
  {
    id: 1,
    mark: '已入库'
  },
  {
    id: 2,
    mark: '无需入库'
  }
]

export {
  paymentStatusOptions,
  invoiceStatusOptions,
  storageStatusOptions
}
